import React, { Fragment } from "react";

// import ArrowIcon from "@mui/icons-material/ArrowForward";
// import amber from "@mui/material/colors/amber";
// import blue from "@mui/material/colors/blue";
// import green from "@mui/material/colors/green";
import { getStateByID } from "../../functions/getStateByID";
import { injectIntl } from "react-intl";
import { getProcessIconByProcessingState } from "./getProcessIconByProcessingState";

/**
 *
 * @param {*} param0
 */
const StateTextAndIconIndicator = ({ status, intl: { formatMessage } }) => {
  const stateType = getStateByID(status);

  if (stateType) {
    return (
      <Fragment>
        <span style={{ marginRight: ".5rem" }}>
          {formatMessage({ id: stateType.i18n })}{" "}
        </span>
        <span>{getProcessIconByProcessingState(status)}</span>
      </Fragment>
    );
  }
  console.warn(`Status "${status}" is not available at present!`);
  return null;
};

/**
 *
 * @param {*} param0
 */
export const StateIconIndicator = ({ status }) => {
  const stateType = getStateByID(status);

  if (stateType) {
    return getProcessIconByProcessingState(status);
  }
  console.warn(`Status "${status}" is not available at present!`);
  return null;
};

export default injectIntl(StateTextAndIconIndicator);
